export const voiceRecorderTimeLimit = 60;
